import React from "react";
import { IComment } from "../../types/Comment.types";
import { CommentHelpers } from "../../helpers/CommentHelper";
import classNames from "classnames";

const Comment: React.FC<IComment> = (props) => {
  return (
    <div className="flex flex-col w-full">
      <div className="flex flex-row justify-between items-center">
        <div className="flex flex-row w-1/2">
          {props.showNew && (
            <div className="flex flex-row items-center">
              <div className="text-[12px] font-medium tracking-[-0.1px] text-cta-red">{"New"}</div>
              <div className="h-[2px] w-[2px] mx-[5px] bg-grey-70 rounded-[2px]" />
            </div>
          )}
          <div className="text-[12px] font-semibold text-grey-90 text-wrap whitespace-break-spaces break-words">
            {props.comment?.displayName}
            {CommentHelpers.getRoleDisplayString(props.comment.role, props.comment.mentorTitle)}
          </div>
        </div>
        <div className="flex flex-row w-1/2 justify-end items-center">
          <div className="flex text-[12px] font-medium tracking-[-0.1px] text-grey-60 text-wrap">
            {CommentHelpers.getFormattedDate(props.comment?.date, props.showTime, props.comment?.editedDate)}
          </div>
          {props.canEdit && (
            <button
              className="flex flex-row bg-grey-20 rounded-[6px] px-2 py-1 ml-1"
              onClick={() => (props.isEditing ? props.cancelEdit?.() : props.editComment?.())}
            >
              <div className="text-[12px] font-semibold tracking-[-0.1px] text-cta-blue">
                {props.isEditing ? "Cancel" : "Edit"}
              </div>
            </button>
          )}
        </div>
      </div>
      <div
        className={classNames(
          "mt-1 mb-4 text-acc-17px leading-default font-medium tracking-default text-grey-90 whitespace-pre-wrap",
          { "!text-grey-60": props.isEditing }
        )}
      >
        {props.comment.comment}
      </div>
    </div>
  );
};

export default Comment;
